import React, { useEffect, useState } from 'react';
import { GiftOrderList, getGiftCardOrder } from '../../actions/auth';
import Header from '../layout/Header';
import Paginated from './Paginated';
import { COLUMN } from './COLUMN';
import { getDate } from '../../utils/helper';
import AdminHeader from '../layout/AdminHeader';

const GiftCardOrder = () => {
	const [formData, setFormData] = useState([]);
	const [loader, setLoader] = useState(false);
	const [response, setResponse] = useState();
	const [matchedData, setMatchedData] = useState([]);
	const merchantId = localStorage.getItem('merchantId');

	const updateData = async () => {
		setLoader(true);
		const token = JSON.parse(localStorage.getItem('token_gen1'));
		const response = getGiftCardOrder(token?.access_token).then((res) => {
			setResponse(res.message.data);
			setLoader(false);
		});
	};

	useEffect(() => {
		sessionStorage.removeItem('venClientCode');
		sessionStorage.removeItem('usermerchcode');
		updateData();
	}, []);

	useEffect(() => {
		if (response?.length > 0) {
			const filteredData = response.filter(
				(item) => item.merchantCode === merchantId,
			);

			setMatchedData(filteredData);
		}
	}, [response, merchantId]);

	useEffect(() => {
		if (matchedData) {
			const tempData = matchedData.map((val) => ({
				...val,
				name: val.giftcardName,
				price: val.price,
				quantity: val.quantity,
				discount: val.discount,
				saving: val.saving,
				total: val.total,
				OrderDate: getDate(val.createdAt, 'DD-MM-YYYY'),
			}));
			if (tempData) {
				tempData.sort(function (a, b) {
					if (a.createdAt === null) {
						return 1;
					} else if (b.createdAt === null) {
						return -1;
					}
					const dateA = new Date(a.createdAt);
					const dateB = new Date(b.createdAt);
					if (dateA < dateB) {
						return 1;
					} else if (dateA > dateB) {
						return -1;
					} else {
						const timeA = dateA.getTime();
						const timeB = dateB.getTime();
						return timeB - timeA;
					}
				});
			}
			setFormData(tempData);
		}
	}, [matchedData]);

	return (
		<>
			<AdminHeader name={'Gift Card Order History'} />
			{loader && (
				<div className='mainPreloaderMain'>
					<div className='mainPreloader'>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			)}
			<div className='dashboard__content'>
				<div className='container-fluid'>
					<div className='row'>
						<div className='dashboard__customersCard'>
							<div className='dashboard__header'>
								<div className='dashboard__left'>
									<h4 id='voucher_details'>Order History</h4>
								</div>
							</div>
							<div className='dashboard__body'>
								<Paginated
									data={formData ? formData : []}
									columns={COLUMN}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default GiftCardOrder;
